module.exports = __webpack_public_path__ + "static/media/akhil_animated.0eb30a53.png";